import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Calendar {
  id?: string
  payrollId: string
  startDate: string
  endDate: string
  frequency: string
  period: string
  subPeriod: string
  year: string
  createMassive: boolean
}

export async function getYears(): Promise<any> {
  const where = ['payroll_id = :payrollId']
  const response: any = await getData({
    tables: ['pg_calendars'],
    fields: ['DISTINCT year as id', 'year as name'],
    where,
    modifier: ['order by year desc'],
    options: {
      outputFormat: 'json'
    }
  })

  return response[0].results
}

export async function getCalendars(
  offset: number,
  perPage: number,
  dataOrder: string,
  year: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['payroll_id = :payrollId']
  if (search) {
    where.push(
      `CONCAT(start_date,end_date,period,sub_period) ILIKE '%${search}%'`
    )
  }

  if (year) {
    where.push(`year = '${year}'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_calendars'],
    fields: [
      'id',
      'year',
      'period',
      'sub_period',
      'start_date',
      'end_date',
      'updated_at'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return response
}

export async function getCalendar(id: string): Promise<Calendar> {
  const data = await getData<any>({
    tables: ['pg_calendars'],
    fields: [
      "TO_CHAR(start_date,'yyyy-mm-dd') as startDate",
      "TO_CHAR(end_date,'yyyy-mm-dd') as endDate",
      'period',
      'sub_period as subPeriod',
      'year',
      'id',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function getFrequencyPayroll(
  id: string | undefined = ''
): Promise<any> {
  const data = await getData<any>({
    tables: ['pg_payrolls'],
    fields: ['frequencies.days'],
    where: [`payrolls.id = '${id}'`],
    join: ['INNER JOIN frequencies ON payrolls.frequency_id = frequencies.id'],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCalendar(data: Calendar): Promise<boolean> {
  const response: any = await http.post('payroll/calendars', {
    payrollId: data.payrollId,
    startDate: data.startDate,
    endDate: data.endDate,
    frequency: data.frequency,
    period: data.period,
    subPeriod: data.subPeriod,
    year: data.year,
    createMasive: data.createMassive,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCalendar(
  data: Calendar,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/calendars/' + id, {
    startDate: data.startDate,
    endDate: data.endDate,
    period: data.period,
    subPeriod: data.subPeriod,
    year: data.year,
    frequency: data.frequency,
    createMassive: data.createMassive
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCalendar(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/calendars/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
